const actions = {
  SPL_DASHBOARD_DATA_BEGIN: 'SPL_DASHBOARD_DATA_BEGIN',
  SPL_DASHBOARD_DATA_SUCCESS: 'SPL_DASHBOARD_DATA_SUCCESS',
  SPL_DASHBOARD_DATA_ERR: 'SPL_DASHBOARD_DATA_ERR',

  getSplDashboardDataBegin: () => ({
    type: actions.SPL_DASHBOARD_DATA_BEGIN,
  }),

  getSplDashboardDataSuccess: (data) => ({
    type: actions.SPL_DASHBOARD_DATA_SUCCESS,
    data,
  }),

  getSplDashboardDataErr: (err) => ({
    type: actions.SPL_DASHBOARD_DATA_ERR,
    err,
  }),
};

export default actions;
